import React, { useState } from 'react'
import { Input } from 'antd'
import styles from './Less/searchInput.less'
const { Search } = Input

interface SearchInputInterface {
    placeHolder?: string
    width?: string
    onSearch?: (data: any) => void
    onChange?: (data: any) => void
    value?: string
}

const SearchInput = (props: SearchInputInterface): React.ReactElement => {
    const {
        placeHolder = 'To filter the clients by number /name',
        width = 378,
        // onSearch,
        onChange,
        value,
    } = props
    const [inputValue, setInputValue] = useState(value ?? '')
    // Function to sanitize input and prevent SQL injection
    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ): void => {
        let newValue = e?.target?.value ?? ''

        // Remove dangerous SQL keywords and symbols
        const sqlInjectionPatterns = [
            // /--/g, // Remove SQL comments
            /#/g, // Remove hash comments
            /\b(SELECT|INSERT|UPDATE|DELETE|DROP|UNION|ALTER|EXEC|MERGE|CALL|OR|AND)\b/gi, // Remove SQL keywords
            /[;\\*=%<>^&@$!/,?|]/g, // Remove semicolon, quotes, and backslashes
        ]

        sqlInjectionPatterns?.forEach((pattern) => {
            newValue = newValue?.replace(pattern, '')
        })

        setInputValue(newValue) // Update state
        onChange?.(newValue) // Call parent handler if provided
    }
    return (
        <div className={styles.searchDiv}>
            <Search
                placeholder={placeHolder}
                onChange={handleInputChange}
                // onSearch={onSearch}
                style={{ width: width + 'px' }}
                className={styles.searchStyles}
                value={inputValue ?? ''}
                allowClear
                enterButton={false}
                maxLength={50}
            />
        </div>
    )
}

export default SearchInput
